import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

import { Tournament } from './code/api';
import * as DayJS from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tournaments',
  props: { tournaments: Array },
  setup(__props) {

const props = __props



const columns: Array<any> = [
  { name: 'JoinTimestamp', label: 'Join Time', field: (t: Tournament) => DayJS.unix(t.CreationTimestamp).format('DD-MM-YY HH:mm'), sortable: false, sort: (a: any, b: any) => a - b },
  { name: 'type', label: 'Type', field: (t: Tournament) => t.TournamentDefinition.TournamentType, sortable: true },
  { name: 'score', label: 'Score', field: (t: Tournament) => t.Score, sortable: true },
  { name: 'Opponent', label: 'Opponent', field: (t: Tournament) => t.OpponentName  },
  { name: 'Opponent ID', label: 'Opponent ID', field: (t: Tournament) => t.OpponentID  },
  { name: 'Tournament', label: 'Tournament', field: (t: Tournament) => t.TournamentDefinition.DisplayName, sortable: true },
  {
    name: 'prize', align: 'center', label: 'Prize', field: (t: Tournament) => {
      const claimStatePrefix = (!!t.ClaimPrizeID ? '⌛️ ' : '✅ ');
      if (t.PrizeAmountGems) {
        return claimStatePrefix + t.PrizeAmountGems + '💎'
      }
      if (t.PrizeAmountCash) {
        return claimStatePrefix + t.PrizeAmountCash + '💰' + (!!t.PrizeAmountBonusCash ? '(' + t.PrizeAmountBonusCash + 'B)' : '')
      }

      return '❌'
    }, sortable: true
  },
  { name: 'participants', label: 'Participants', field: (t: Tournament) => t.ParticipantsCount + " / " + t.TournamentDefinition.ParticipantsCount, sortable: true }, {
    name: 'ID',
    required: true,
    label: 'ID',
    align: 'left',
    field: (t: any) => { return t.ID },
    sortable: true
  },
  { name: 'logs', label: 'Logs', field: (t: Tournament) => !!t.GameSession?.GameSessionArn ? '💾' : "N/A" }
]

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      color: "red",
      title: "Tournaments 🎱",
      rows: props.tournaments,
      columns: columns,
      "row-key": "name"
    }, {
      "body-cell-logs": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              color: "primary",
              icon: "download",
              label: "Logs",
              onClick: ($event: any) => (_ctx.$emit('onLogsClick', props))
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              color: "primary",
              label: "Copy Game Moves",
              onClick: ($event: any) => (_ctx.$emit('downloadGameMovesClicked', props))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["rows"])
  ]))
}
}

})